/*
 * @Description: 用户登录状态模块
 * @Author: hai-27
 * @Date: 2020-02-19 17:42:11
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-26 23:14:32
 */
import { logout } from '@/api/login'
import { getToken, removeToken } from '@/utils/auth'
import router from '../../router'
export default {
  state: {
    token: getToken(),
    user: '', // 登录的用户
    cartNumber: 0,
    mailCount: 0,
    cartList: [],
    searchStr: '',
    search: {
      cutOffTimeStart: null,
      cutOffTimeEnd: null,
      launchTimeStart: null,
      launchTimeEnd: null,
      saleTimeStart: null,
      saleTimeEnd: null,
      sids: [],
      isForm: false
    },
    showLogin: false // 用于控制是否显示登录组件
  },
  getters: {
    getTokenKy (state) {
      return state.token
    },
    getUser (state) {
      console.log(state)
      return state.user
    },
    getCartNumber (state) {
      return state.cartNumber
    },
    getCartList (state) {
      return state.cartList
    },
    getShowLogin (state) {
      return state.showLogin
    },
    getSearchStr (state) {
      return state.searchStr
    },
    getSearch (state) {
      return state.search
    },
    getMailCount (state) {
      return state.mailCount
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    setUser (state, data) {
      console.log(data + '777777777')
      state.user = data
    },
    setShowLogin (state, data) {
      state.showLogin = data
    },
    setSearchStr (state, data) {
      state.searchStr = data
    },
    setCartNumber (state, data) {
      state.cartNumber = data
    },
    setCartList (state, data) {
      state.cartList = data
    },
    setSearch (state, search) {
      state.search = search
    },
    setMailCount (state, mailCount) {
      state.mailCount = mailCount
    }
  },
  actions: {
    setUser ({ commit }, data) {
      commit('setUser', data)
    },
    setToken ({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    setShowLogin ({ commit }, data) {
      console.log(data)
      commit('setShowLogin', data)
    },
    setSearchStr ({ commit }, data) {
      commit('setSearchStr', data)
    },
    setCartNumber ({ commit }, data) {
      commit('setCartNumber', data)
    },
    setCartList ({ commit }, data) {
      commit('setCartList', data)
    },
    setSearch ({ commit }, data) {
      commit('setSearch', data)
    },
    setMailCount ({ commit }, data) {
      commit('setMailCount', data)
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
          router.push({ path: '/' })
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    }
  }
}
export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('setUser', {})
  removeToken()
}

export const setUserInfo = (res, commit) => {
  commit('SET_USER', res)
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js